


































import { computed, defineComponent, ref } from "@vue/composition-api";
import useOnUserLogin from "@/hooks/useOnUserLogin";
import { isIOS, isWebApp } from "@/lib/browserUtils";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";

const WEEK_MILLISECONDS = 1000 * 60 * 60 * 24 * 7;
const IOS_DATE_LOCAL_STORAGE_KEY = "dateIosPushSeen";

export default defineComponent({
  name: "IosPushNotificationReminder",
  components: { BaseConfirm, BaseButton, BaseIcon },
  setup() {
    const showReminder = ref(false);

    const show = computed(() => isIOS() && !isWebApp && showReminder.value);
    const siteName = computed(() => (!!config.soloCreatorId ? config.siteName : "Fanzter"));
    const isSoloCreator = computed(() => !!config.soloCreatorId);

    const handleClose = () => (showReminder.value = false);

    const title = computed(() => {
      return isSoloCreator ? $t("How to install app on your iOS") : $t("How to install Fanzter on iOS");
    });

    const checkDate = (): void => {
      if (!isIOS() || isWebApp) {
        return;
      }

      const pushDate = Date.parse(localStorage.getItem(IOS_DATE_LOCAL_STORAGE_KEY) || "");
      const diff = Math.abs(pushDate - Date.now());
      if (isNaN(pushDate) || isNaN(diff)) {
        localStorage.setItem(IOS_DATE_LOCAL_STORAGE_KEY, new Date().toISOString());
        showReminder.value = true;
        return;
      }
      if (diff < WEEK_MILLISECONDS) {
        return;
      }
    };

    useOnUserLogin(() => {
      checkDate();
    });
    checkDate();

    return { title, show, handleClose, isSoloCreator, siteName };
  },
});
